import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import { AppContainer, MainContent, ContentArea } from './App.styles';

// Authenticated App Shell with Idle Timer
function AuthenticatedAppShell({ children, sidebarOpen, setSidebarOpen }) {
  // Note: navigate is available but not currently used in this component
  const [sessionConfig, setSessionConfig] = useState(null);

  // Fetch session configuration on mount
  useEffect(() => {
    const fetchSessionConfig = async () => {
      try {
        const response = await fetch('/portal/api/auth/session-config', {
          credentials: 'include'
        });
        const config = await response.json();
        setSessionConfig(config);
      } catch (error) {
        console.warn('Failed to fetch session config, using defaults:', error);
        // Fallback to default values
        setSessionConfig({
          idleTimeoutSeconds: 1800, // 30 minutes
          idleWarningSeconds: 60,   // 1 minute
          heartbeatMs: 60000        // 1 minute
        });
      }
    };

    fetchSessionConfig();
  }, []);


  // Don't render until we have session config
  if (!sessionConfig) {
    return (
      <AppContainer>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid var(--border-color)',
            borderTop: '4px solid var(--primary-color)',
            borderRadius: 0,
            animation: 'spin 1s linear infinite'
          }}></div>
        </div>
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <Header onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
      <MainContent>
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
      {/* Scroll-to-top button removed - using GlobalScrollToTop component */}
    </AppContainer>
  );
}

export default AuthenticatedAppShell;
